// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__3leNm","loader":"Loader_loader__1t_me","rotate":"Loader_rotate__2W2MQ","path":"Loader_path__1X9n7","dash":"Loader_dash__2_LlE"};